angular.module('psModule').controller('SimulationDetailModalCtrl', ['$scope', 'calculationParams', function($scope, calculationParams){
    $scope.annualInterest = calculationParams['prp_annual_interest'];
    $scope.annualInterestTrad = calculationParams['prp_annual_interest_trad'];
    $scope.percentageFeeFund = calculationParams['prp_percentage_fee_fund'];
    $scope.percentageFeeTrad = calculationParams['prp_percentage_fee_trad'];
    $scope.taxPercentageCapital = calculationParams['prp_tax_percentage_capital'];
    $scope.taxPercentagePension = calculationParams['prp_tax_percentage_pension'];
}]);
